import { localStorageManager } from "@/services/localStorage";
import { useState } from "react";
import { TableLayoutState } from "@/components/Base/Datatable";

export const useUserColumns = (
  key: string,
  defaultState: TableLayoutState = {}
) => {
  const [, refresh] = useState({});

  try {
    defaultState = JSON.parse(
      localStorageManager.getItem(key) ?? ""
    ) as TableLayoutState;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    // noop
  }

  const saveTableLayout = (state: TableLayoutState) => {
    localStorageManager.setItem(key, JSON.stringify(state));
    refresh({});
  };
  const resetTableLayout = () => {
    localStorageManager.setItem(key, "");
    refresh({}); // refresh to apply defaults
  };

  return { defaultState, saveTableLayout, resetTableLayout };
};
